export default __webpack_public_path__ + "static/char-sp02-anr-75fdf6327227c4adaabe23039bda3920.gif";